export const document = {
  status: [{
    value: 0, label: '有效'}, {
    value: -1, label: '无效'}]
}

export default {
  document
}



// WEBPACK FOOTER //
// ./src/data/document.js